import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfigService } from '../../../../helpers/config.service';
import { AuthAPIService } from '../../services/auth-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-verify-changes',
  templateUrl: './verify-changes.component.html',
  styles: ``
})
export class VerifyChangesComponent implements OnInit {

  loading: boolean = false;

  constructor(public dialogRef: MatDialogRef<VerifyChangesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _config: ConfigService,
    private _AuthApiService: AuthAPIService,
    private _router: Router) {

  }
  ngOnInit(): void {

  }

  OnConfirm() {
    this.loading = true;
    this._AuthApiService.VerifyChanges(this.data).subscribe({
      next: (res) => {
        this.loading = false;
        this.dialogRef.close();
        this.OpenSuccessMessage();
      },
      error: (error) => {
        this.loading = false;
        this.dialogRef.close();
        // Swal.fire({
        //   title: this._config._translate.instant('swalMsg.Failed'),
        //   text: error.errors[0].massage,
        //   icon: 'error',
        //   confirmButtonText: this._config._translate.instant('swalMsg.Ok'),
        // })
      },
    })
  }


  OpenSuccessMessage() {
    this.dialogRef.close();
    this._config.SusseccMessage(this._config._translate.instant("userProfile.Changes has been updated"))
  }


}
